import React from "react"

class FourOFour extends React.Component {
  render() {
    return <h1 css={{ margin: `auto` }}>Page not found</h1>
  }
}

export default FourOFour



// WEBPACK FOOTER //
// ./src/pages/404.js